module.exports = __webpack_public_path__ + "staticfr/media/orquestra.2a53859a.mp4";